import { OffchainAccount, OffchainAccountBorrowable, OffchainAccountCollateral, OffchainAccountLendingPool, OffchainAccountPoolToken, OffchainBorrowable, OffchainCollateral, OffchainLendingPool, OffchainPoolToken, PoolTokenType, offchain } from 'impermax-sdk';
import { useContext } from 'react';
import { OffchainContext } from '../contexts/OffchainProvider';
import useAccount from './useAccount';
import useFactory from './useFactory';
import useGenericCall from './useGenericCall';
import usePairAddress from './usePairAddress';
import usePoolToken from './usePoolToken';

export default function useOffchainInstance() {
  const { offchainInstance } = useContext(OffchainContext);
  return offchainInstance;
}

export function useOffchainLendingPool() : OffchainLendingPool {
  const factory = useFactory();
  const pairAddress = usePairAddress();
  const offchainInstance = useOffchainInstance();
  return useGenericCall(offchainInstance, offchainInstance => offchainInstance.getLendingPool(factory, pairAddress));
}

export function useOffchainPoolToken(poolTokenTypeArg?: PoolTokenType) : OffchainPoolToken {
  const poolTokenType = poolTokenTypeArg ? poolTokenTypeArg : usePoolToken();
  const lendingPool = useOffchainLendingPool();
  return lendingPool ? lendingPool.getPoolToken(poolTokenType) : null;
}

export function useOffchainBorrowable(poolTokenTypeArg?: PoolTokenType) : OffchainBorrowable {
  return useOffchainPoolToken(poolTokenTypeArg) as OffchainBorrowable;
}

export function useOffchainCollateral() : OffchainCollateral {
  return useOffchainPoolToken(PoolTokenType.Collateral) as OffchainCollateral;
}

export function useOffchainAccount() : OffchainAccount {
  const offchainInstance = useOffchainInstance();
  const account = useAccount();
  return offchainInstance ? offchainInstance.getAccount(account) : null;
}

export function useOffchainAccountLendingPool() : OffchainAccountLendingPool {
  const factory = useFactory();
  const pairAddress = usePairAddress();
  const offchainAccount = useOffchainAccount();
  return useGenericCall(offchainAccount, offchainAccount => offchainAccount.getLendingPool(factory, pairAddress));
}

export function useOffchainAccountPoolToken(poolTokenTypeArg?: PoolTokenType) : OffchainAccountPoolToken {
  const poolTokenType = poolTokenTypeArg ? poolTokenTypeArg : usePoolToken();
  const accountLendingPool = useOffchainAccountLendingPool();
  return accountLendingPool ? accountLendingPool.getPoolToken(poolTokenType): null;
}

export function useOffchainAccountBorrowable(poolTokenTypeArg?: PoolTokenType) : OffchainAccountBorrowable {
  return useOffchainAccountPoolToken(poolTokenTypeArg) as OffchainAccountBorrowable;
}

export function useOffchainAccountCollateral() : OffchainAccountCollateral {
  return useOffchainAccountPoolToken(PoolTokenType.Collateral) as OffchainAccountCollateral;
}